module.exports = __webpack_public_path__ + "static/media/tel.dc1e5d3c.svg";